/**
 * @file getTextDirection.js
 * @description Resuelve direccion de texto por idioma para contenedores locales.
 */

const RTL_LANGUAGES = new Set(['ar', 'he']);

export function getTextDirection(language) {
  const lang = String(language || '').toLowerCase().slice(0, 2);
  return RTL_LANGUAGES.has(lang) ? 'rtl' : 'ltr';
}

export default getTextDirection;
